export enum ClarityEventEnum {
	VIEW_HOME_PAGE = 'visualizou_home_page',
}
